import LoadingDots from './loading-dots-view'

export default LoadingDots
